import type { UniclientComponentTitle } from '@lemonade-hq/uniclient-chat';
import { MIN_COMPONENT_ANIMATION_DELAY } from '../animators/durations';
import { formattedTextToString } from './parseFormattedTitle';

export const getTitleLength = (title: UniclientComponentTitle | undefined): number => {
  if (typeof title === 'string') return title.length;
  if (typeof title === 'object') return formattedTextToString(title.text).length;
  else return MIN_COMPONENT_ANIMATION_DELAY;
};
